import { render } from "./ModelDetails.vue?vue&type=template&id=e6d605c6"
import script from "./ModelDetails.vue?vue&type=script&lang=js"
export * from "./ModelDetails.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__